import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { MdOutlineMoodBad, MdDashboard, MdPeople, MdAssignment, MdDescription } from "react-icons/md";
import InquiryDetail from "Components/InquiryDetail";
import CommonModal from "Components/CommonModal";
import { catchError } from "JS/common";
import { markTypeList } from "JS/array";
import {
  getUserCount,
  getInquiryList,
  getApplicationCount,
  getSelfApplicationCount,
  getReviewRequest,
  getPatentDesignRequestList,
} from "JS/API";
import { detailPageStyles, listPageStyles } from "utils/designSystem";
import { formatDate } from "utils/patentDesign";

const Home = () => {
  //= 유저 카운트
  const [newUser, setNewUser] = useState("");
  const [allUser, setAllUser] = useState("");
  //= 셀프 출원 카운트
  const [selfList, setSelfList] = useState([]);
  const [selfCount, setSelfCount] = useState({});
  //= 출원 대행 카운트
  const [applicationList, setApplicationList] = useState([]);
  const [applicationCount, setApplicationCount] = useState({});

  const [inquiryId, setInquiryId] = useState("");
  const [, setReviewId] = useState("");

  const [, setState] = useState("");
  const [recentInquiry, setRecentInquiry] = useState([]);
  const [recentReview, setRecentReview] = useState([]);
  const [newPatentDesign, setNewPatentDesign] = useState([]);

  const [inquiryModal, setInquiryModal] = useState(false);

  const [alert, setAlert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });

  const navigate = useNavigate();
  let prevent = false;

  // 스타일 정의 - 더 어둡고 대비가 명확한 버전
  const styles = {
    container: listPageStyles.container,
    header: {
      marginBottom: '32px'
    },
    title: listPageStyles.title,
    statsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
      gap: '20px',
      marginBottom: '32px'
    },
    statCard: {
      backgroundColor: '#ffffff',
      padding: '24px',
      borderRadius: '12px',
      border: '1px solid #cbd5e1',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease'
    },
    statHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      marginBottom: '16px'
    },
    statTitle: {
      fontSize: '13px',
      fontWeight: '600',
      color: '#475569',
      textTransform: 'uppercase',
      letterSpacing: '0.05em'
    },
    statValue: {
      fontSize: '32px',
      fontWeight: '700',
      color: '#0f172a',
      marginBottom: '4px'
    },
    statLabel: {
      fontSize: '14px',
      color: '#64748b'
    },
    contentGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
      gap: '24px'
    },
    section: {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      border: '1px solid #cbd5e1',
      overflow: 'hidden'
    },
    sectionHeader: {
      padding: '20px 24px',
      borderBottom: '1px solid #cbd5e1',
      backgroundColor: '#f8fafc',
      display : 'flex',
      gap : '10px',
      alignItems : 'center'
    },
    sectionTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#0f172a',
      margin: 0,
      marginBottom: '4px'
    },
    sectionSubtitle: {
      fontSize: '14px',
      color: '#64748b',
      margin: 0
    },
    tableContainer: {
      overflow: 'auto',
      maxHeight: '300px'
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse'
    },
    th: detailPageStyles.th,
    td: detailPageStyles.td,
    tableRow: {
      cursor: 'pointer',
      transition: 'background-color 0.2s ease'
    },
    tableRowHover: {
      backgroundColor: '#f1f5f9'
    },
    emptyState: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 24px',
      color: '#64748b'
    },
    emptyIcon: {
      fontSize: '48px',
      marginBottom: '12px',
      color: '#94a3b8'
    },
    emptyText: {
      fontSize: '14px',
      color: '#64748b',
      fontWeight: '500'
    }
  };

  //@ 7 특허·디자인 신청
  const getNewPatentDesign = async () => {
    const result = await getPatentDesignRequestList({ page: 1, limit: 5, status: "received" });
    if (typeof result !== "object")
      return catchError(result, navigate, setAlertBox, setAlert);
    setNewPatentDesign(result.data?.data || []);
  };

  //@ 6 문의사항
  const getInquiry = async () => {
    const result = await getInquiryList(1, 5, "notanswer", "all");
    if (typeof result !== "object")
      return catchError(result, navigate, setAlertBox, setAlert);
    const arr = [];
    for (let obj of result.data.data) arr.push(obj);
    setRecentInquiry(arr);
  };

  //@ 5 검토요청
  const getReview = async () => {
    const result = await getReviewRequest(
      { page: 1, limit: 5 },
      {
        markName: "",
        templateName: "",
        applicantName: "",
        startDate: "",
        endDate: "",
        markType: "all",
      }
    );
    if (typeof result !== "object")
      return catchError(result, navigate, setAlertBox, setAlert);
    const arr = result.data?.data || [];
    setRecentReview(arr);
  };

  //@ 4
  const getSelfApplication = async () => {
    const result = await getSelfApplicationCount();
    if (typeof result !== "object")
      return catchError(result, navigate, setAlertBox, setAlert);
    setSelfCount(result?.data?.info);
    setSelfList(result?.data?.content);
  };

  //@ 3
  const getApplication = async () => {
    const result = await getApplicationCount();
    if (typeof result !== "object")
      return catchError(result, navigate, setAlertBox, setAlert);
    setApplicationCount(result?.data?.info);
    setApplicationList(result?.data?.content);
  };

  //@ 2
  const getTodayUser = async () => {
    const result = await getUserCount("month");
    if (typeof result !== "object")
      return catchError(result, navigate, setAlertBox, setAlert);
    setNewUser(result?.data?.data);
  };

  //@ 1
  const getAllUser = async () => {
    if (prevent) return;
    prevent = true;
    setTimeout(() => {
      prevent = false;
    }, 200);
    const result = await getUserCount("all");
    if (typeof result !== "object")
      return catchError(result, navigate, setAlertBox, setAlert);
    else {
      setState("ok");
      setAllUser(result?.data?.data);
    }
  };

  //= 셀프 출원 리스트 렌더
  const renderSelfApplicationList = () => {
    return selfList?.map(
      ({ applicant_name, template_name, mark_name, mark_type, id }, idx) => {
        return (
          <tr 
            key={id}
            style={styles.tableRow}
            onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
            onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
            onClick={() => navigate(`/self-application/${id}`)}
          >
            <td style={styles.td}>{template_name}</td>
            <td style={styles.td}>{mark_name}</td>
            <td style={styles.td}>
              {mark_type === 'text'
                ? '문자상표'
                : mark_type === 'compound'
                  ? '복합상표'
                  : '도형상표'}
            </td>
            <td style={styles.td}>
              {applicant_name?.split(",")?.length === 1
                ? applicant_name
                : `${applicant_name?.split(",")[0]} 외 ${applicant_name?.split(",")?.length - 1}명`}
            </td>
          </tr>
        );
      }
    );
  };

  //= 상표 출원 대행 리스트 렌더
  const renderApplicationList = () => {
    return applicationList?.map(
      ({ applicant_name, mark_name, mark_type, paid_amount, id }, idx) => {
        return (
          <tr 
            key={id}
            style={styles.tableRow}
            onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
            onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
            onClick={() => navigate(`/agencies/${id}`)}
          >
            <td style={styles.td}>{mark_name}</td>
            <td style={styles.td}>{markTypeList[mark_type]}상표</td>
            <td style={styles.td}>{paid_amount?.toLocaleString()}원</td>
            <td style={styles.td}>{applicant_name}</td>
          </tr>
        );
      }
    );
  };

  //= 검토요청 리스트 렌더
  const reviewListRender = () => {
    return recentReview?.map(({ template_name, applicant_name, review_status, created_at, id }) => {
      return (
        <tr
          key={id}
          style={styles.tableRow}
          onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
          onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
          onClick={() => {
            setReviewId(id);
            navigate(`/review-self/${id}`)
          }}
        >
          <td style={styles.td}>{template_name}</td>
          <td style={styles.td}>{applicant_name}</td>
          <td style={styles.td}>
            {{ request: "요청", processing: "진행중", completed: "완료", rejected: "거절", canceled: "취소" }[review_status] || review_status}
          </td>
          <td style={styles.td}>{created_at?.split("T")[0]}</td>
        </tr>
      );
    });
  };

  //= 특허·디자인 신청 리스트 렌더
  const patentDesignListRender = () => {
    return newPatentDesign?.map(({ id, title, user, created_at }) => {
      return (
        <tr
          key={id}
          style={styles.tableRow}
          onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
          onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
          onClick={() => navigate(`/patent-design/${id}`)}
        >
          <td style={styles.td}>{title}</td>
          <td style={{ ...styles.td, whiteSpace: "nowrap" }}>{user?.name}</td>
          <td style={{ ...styles.td, whiteSpace: "nowrap" }}>{formatDate(created_at)}</td>
        </tr>
      );
    });
  };

  //= 문의사항 리스트 렌더
  const inquiryListRender = () => {
    return recentInquiry?.map(({ title, user_name, created_at, id }) => {
      return (
        <tr
          key={id}
          style={styles.tableRow}
          onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
          onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
          onClick={() => {
            setInquiryId(id);
            setInquiryModal(true);
          }}
        >
          <td style={styles.td}>{title}</td>
          <td style={styles.td}>{user_name}</td>
          <td style={styles.td}>{created_at?.split("T")[0]}</td>
        </tr>
      );
    });
  };

  const didFetch = useRef(false);

  useEffect(() => {
    if (didFetch.current) return;
    didFetch.current = true;

    getAllUser();
    getInquiry();
    getNewPatentDesign();
    getReview();
    getSelfApplication();
    getApplication();
    getTodayUser();
    document.title = "마크픽 관리자 > 홈";
  }, []);

  return (
    <div style={styles.container}>
      {/* 헤더 */}
      <div style={styles.header}>
        <h1 style={styles.title}>
          <MdDashboard />
          DASHBOARD
        </h1>
      </div>

      {/* 통계 카드 */}
      <div style={styles.statsGrid}>
        <div 
          style={styles.statCard}
          onMouseEnter={(e) => Object.assign(e.target.style, styles.statCardHover)}
          onMouseLeave={(e) => {
            e.target.style.transform = 'translateY(0)';
            // e.target.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
          }}
        >
          <div style={styles.statHeader}>
            <MdPeople style={{ color: '#3b82f6', fontSize: '20px' }} />
            <h3 style={styles.statTitle}>회원 현황</h3>
          </div>
          <div style={styles.statValue}>
            {newUser} / {allUser}
          </div>
          <div style={styles.statLabel}>신규 / 전체</div>
        </div>

        <div 
          style={styles.statCard}
          onMouseEnter={(e) => Object.assign(e.target.style, styles.statCardHover)}
        >
          <div style={styles.statHeader}>
            <MdAssignment style={{ color: '#10b981', fontSize: '20px' }} />
            <h3 style={styles.statTitle}>셀프 출원 현황</h3>
          </div>
          <div style={styles.statValue}>
            {selfCount?.count} / {selfCount?.total}
          </div>
          <div style={styles.statLabel}>오늘 / 전체</div>
        </div>

        <div 
          style={styles.statCard}
          onMouseEnter={(e) => Object.assign(e.target.style, styles.statCardHover)}
        >
          <div style={styles.statHeader}>
            <MdDescription style={{ color: '#f59e0b', fontSize: '20px' }} />
            <h3 style={styles.statTitle}>출원 신청 현황</h3>
          </div>
          <div style={styles.statValue}>
            {applicationCount?.today_count} / {applicationCount?.total_count}
          </div>
          <div style={styles.statLabel}>오늘 / 전체</div>
        </div>
      </div>

      {/* 메인 콘텐츠 그리드 */}
      <div style={styles.contentGrid}>
        {/* 문의사항 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>최근 업로드 된 문의 사항</h2>
          </div>
          {!recentInquiry?.length ? (
            <div style={styles.emptyState}>
              <MdOutlineMoodBad style={styles.emptyIcon} />
              <p style={styles.emptyText}>문의사항이 없습니다</p>
            </div>
          ) : (
            <div style={styles.tableContainer}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>제목</th>
                    <th style={styles.th}>작성자</th>
                    <th style={styles.th}>문의 날짜</th>
                  </tr>
                </thead>
                <tbody>{inquiryListRender()}</tbody>
              </table>
            </div>
          )}
        </div>

        {/* 검토요청 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>최근 출원검토 요청 목록</h2>
          </div>
          {!recentReview?.length ? (
            <div style={styles.emptyState}>
              <MdOutlineMoodBad style={styles.emptyIcon} />
              <p style={styles.emptyText}>검토요청이 없습니다</p>
            </div>
          ) : (
            <div style={styles.tableContainer}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>템플릿명</th>
                    <th style={styles.th}>작성자</th>
                    <th style={styles.th}>검토여부</th>
                    <th style={styles.th}>등록 일자</th>
                  </tr>
                </thead>
                <tbody>{reviewListRender()}</tbody>
              </table>
            </div>
          )}
        </div>

        {/* 셀프 출원 목록 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>최근 셀프 출원 목록</h2>
            <p style={styles.sectionSubtitle}>최대 다섯 개까지 표시 됩니다.</p>
          </div>
          {!selfList?.length ? (
            <div style={styles.emptyState}>
              <MdOutlineMoodBad style={styles.emptyIcon} />
              <p style={styles.emptyText}>셀프 출원이 없습니다</p>
            </div>
          ) : (
            <div style={styles.tableContainer}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>템플릿명</th>
                    <th style={styles.th}>출원 상표명</th>
                    <th style={styles.th}>상표 유형</th>
                    <th style={styles.th}>출원인</th>
                  </tr>
                </thead>
                <tbody>{renderSelfApplicationList()}</tbody>
              </table>
            </div>
          )}
        </div>

        {/* 출원 대행 목록 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>최근 출원 신청 목록</h2>
            <p style={styles.sectionSubtitle}>최대 다섯 개까지 표시 됩니다.</p>
          </div>
          {!applicationList?.length ? (
            <div style={styles.emptyState}>
              <MdOutlineMoodBad style={styles.emptyIcon} />
              <p style={styles.emptyText}>출원 신청이 없습니다</p>
            </div>
          ) : (
            <div style={styles.tableContainer}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>출원 상표명</th>
                    <th style={styles.th}>상표 유형</th>
                    <th style={styles.th}>결제 금액</th>
                    <th style={styles.th}>출원인</th>
                  </tr>
                </thead>
                <tbody>{renderApplicationList()}</tbody>
              </table>
            </div>
          )}
        </div>

        {/* 특허·디자인 신청 */}
        <div style={styles.section}>
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>새 특허·디자인 신청</h2>
            <p style={styles.sectionSubtitle}>최대 다섯 개까지 표시 됩니다.</p>
          </div>
          {!newPatentDesign?.length ? (
            <div style={styles.emptyState}>
              <MdOutlineMoodBad style={styles.emptyIcon} />
              <p style={styles.emptyText}>새 특허·디자인 신청이 없습니다</p>
            </div>
          ) : (
            <div style={styles.tableContainer}>
              <table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>제목</th>
                    <th style={styles.th}>신청자</th>
                    <th style={styles.th}>신청일</th>
                  </tr>
                </thead>
                <tbody>{patentDesignListRender()}</tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* 모달들 */}
      {inquiryModal && (
        <InquiryDetail inquiryId={inquiryId} setModal={setInquiryModal} />
      )}
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "logout") navigate("/");
            else return;
          }}
        />
      )}
    </div>
  );
};

export default Home;